module.exports = __webpack_public_path__ + "fonts/OpenSans-Bold.a0fe34b.ttf";